module.exports = __webpack_public_path__ + "static/logoUBS-9b85e423373ed2db93f18fae25d0fa84.png";